module.exports = __webpack_public_path__ + "static/media/indianPlatform.756bda8a.svg";